import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import addressAutocomplete from 'reducers/addressAutocomplete';
import enrollment from 'reducers/enrollment';
import form from 'reducers/form';
import modal from 'reducers/modal';
import pageLoader from 'reducers/pageLoader';
import prefillData from 'reducers/prefillData';
import user from 'reducers/user';
import validationError from 'reducers/validationError';

/*
configuration to persist selected reducers and block specific states within them when rehydrating
*/

const enrollmentPersistConfig = {
  key: 'enrollment',
  storage,
  blacklist: ['requirePhoneVerification'],
};

const userPersistConfig = {
  key: 'user',
  storage,
  blacklist: ['userIsConnected'],
};

export default combineReducers({
  form,
  modal,
  pageLoader,
  addressAutocomplete,
  enrollment: persistReducer(enrollmentPersistConfig, enrollment),
  user: persistReducer(userPersistConfig, user),
  validationError,
  prefillData,
});
